import { API_URL } from "../config/api";
import { sanitizeDisplayName } from "./displayNameSanitize";

const LEGACY_QUEST_PLAYER_NAME_KEY = "vocabularium_quest_player_name";

export function forgetLocalQuestPlayerName() {
  try {
    localStorage.removeItem(LEGACY_QUEST_PLAYER_NAME_KEY);
  } catch {
    // ignore
  }
}

export async function fetchPlayerProfile() {
  forgetLocalQuestPlayerName();
  const res = await fetch(`${API_URL}/profile`);
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    return { displayName: "", admin: false };
  }
  return {
    displayName: sanitizeDisplayName(json.displayName),
    admin: json.admin === true,
  };
}

export async function fetchPlayerDisplayName() {
  const profile = await fetchPlayerProfile();
  return profile.displayName;
}
